import React from "react";
import { Link } from "react-router-dom";
interface SectionTitleProps {
  title: string;
  title2: string;
  subtitle?: string;
}

const ProjectSectionTitle: React.FC<SectionTitleProps> = ({
  title,
  title2,
  subtitle,
}) => {
  return (
    <div className="mb-[2.4rem]">
      <div className="flex justify-between items-center mb-[1.2rem]">
        <h2 className="text-[3.2rem] font-semibold leading-[4rem] text-black">
          {title} <br className="md:hidden" />{" "}
          <span className="text-black">{title2}</span>
        </h2>
        <Link
          to="/developments"
          className="bg-primary flex items-center border border-transparent text-black px-[1.2rem] py-[0.4rem] rounded-[0.5rem] h-[5rem] hover:bg-yellow-400"
        >
          <p className="whitespace-nowrap p-[1rem]">View All</p>
        </Link>
      </div>

      {subtitle && (
        <p className="text-[1.6rem] text-black max-w-[63rem]">{subtitle}</p>
      )}
    </div>
  );
};

export default ProjectSectionTitle;
